import ReduxToolkit, { createSlice } from '@reduxjs/toolkit';

const NAME = 'drawnNumbers';

export type ValueType = number[];

const initialState: ValueType = [];

const setAction: ReduxToolkit.CaseReducer<
	ValueType,
	ReduxToolkit.PayloadAction<ValueType>
> = (state, action) => {
	return action.payload;
};

export const drawnNumbersSlice = createSlice({
	name: NAME,
	initialState,
	reducers: {
		drawnNumbersUpdate: setAction,
	},
});
